import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '@auth/pages/login/login.component';
import { LogoutComponent } from '@auth/pages/logout/logout.component';
import { IsLoggedOutGuard } from '@shared/guards/is-logged-out.guard';
import {IsLoggedInGuard} from '@shared/guards/is-logged-in.guard';
import { TwoFactorVerificationComponent } from './pages/two-factor-verification/two-factor-verification.component';
import { IsIn2FAVerificationGuard } from '@app/shared/guards/IsIn2FAVerification.guard';
import { RemoteAuthGuard } from '@app/shared/guards/remoteAuthHandler.guard';
import { RemoteAuthComponent } from './pages/auth/remoteAuth/remote-auth.component';
import { SsoCallbackComponent } from './sso-callback/sso-callback.component';
const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { title: 'loginTitle' }, canActivate: [IsLoggedOutGuard] },
  { path: 'logout', component: LogoutComponent, data: { title: 'logoutTitle' }, canActivate: [IsLoggedInGuard] },
  {path:'verify',component:TwoFactorVerificationComponent,data:{title:'verify'},canActivate:[IsIn2FAVerificationGuard]},
  { path: 'remote-auth', component: RemoteAuthComponent, data: { title: 'Remote Authentication' }, canActivate: [RemoteAuthGuard] },
  {path:'sso-callback',component:SsoCallbackComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
